export default function (at, add, to) {
  function checkNumber (value) {
    const result = value.match(/^[0-9]+$/g)
    return !!((result !== null && result.length))
  }

  let result = ''

  if (checkNumber(at) && checkNumber(to) && checkNumber(add)) {
    result = Number(at) + Number(add) - Number(to)
    result = (result === 0) ? 'Расхода не было' : result
  } else {
    result = 'Вы ввели некорректные данные'
  }

  return result
}
